export { SelectSearchableVariant } from '@hse-design/core';

var SelectVariant;
(function (SelectVariant) {
    SelectVariant["default"] = "default";
    SelectVariant["borderless"] = "borderless";
})(SelectVariant || (SelectVariant = {}));
var SelectWidthVariant;
(function (SelectWidthVariant) {
    SelectWidthVariant["auto"] = "auto";
    SelectWidthVariant["full"] = "full";
})(SelectWidthVariant || (SelectWidthVariant = {}));
var SelectSize;
(function (SelectSize) {
    SelectSize["small"] = "small";
    SelectSize["medium"] = "medium";
    SelectSize["large"] = "large";
})(SelectSize || (SelectSize = {}));

export { SelectSize, SelectVariant, SelectWidthVariant };
